import script from "./WarningBar.vue?vue&type=script&setup=true&lang=js"
export * from "./WarningBar.vue?vue&type=script&setup=true&lang=js"

import "./WarningBar.vue?vue&type=style&index=0&id=6611ea5e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6611ea5e"]])

export default __exports__